import React from 'react';
import { Badge, BadgeProps } from '@/components/ui/badge';

import './AttentionBadge.css';

type Props = Pick<BadgeProps, 'pill'> & {
  className?: string;
  variant?: BadgeProps['variant'];
  children?: React.ReactNode;
};

const AttentionBadge = React.forwardRef<HTMLSpanElement, Props>(
  ({ className, children, variant, ...rest }, ref) => (
    <Badge
      ref={ref}
      className={[`d-flex align-items-center`, className].join(' ')}
      variant={variant}
      {...rest}>
      {children}
    </Badge>
  ),
);

export default AttentionBadge;
